<template>
  <button
    @click="buttonclick"
    class="bg-transparent hover:bg-green-700 text-green-700 font-semibold hover:text-white py-2 border border-green-500 hover:border-transparent rounded"
  >
    <beat-loader :loading="isLoading" :color="'#68d391'" :size="8" />
    <p v-show="!isLoading">
      <slot v-show="isLoading"></slot>
    </p>
  </button>
</template>

<script>
export default {
  name: "PxButton",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    buttonclick() {
      this.$emit("custom-click");
    }
  }
};
</script>
